import { render, staticRenderFns } from "./CurrentRentalNttWestWifiRouter.vue?vue&type=template&id=22b6b3f1&scoped=true&"
import script from "./CurrentRentalNttWestWifiRouter.vue?vue&type=script&lang=ts&"
export * from "./CurrentRentalNttWestWifiRouter.vue?vue&type=script&lang=ts&"
import style0 from "./CurrentRentalNttWestWifiRouter.vue?vue&type=style&index=0&id=22b6b3f1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b6b3f1",
  null
  
)

export default component.exports